module.exports = __webpack_public_path__ + "img/bg-01.38fc6361.png";